import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import darkIcon from "../../assets/img/icon-dark-theme.svg";
import lightIcon from "../../assets/img/icon-light-theme.svg";
import { Switch } from "@headlessui/react";
import useDarkMode from "../../../hooks/useDarkMode";
import { guestToken, login } from "../../../redux/auth/actions";

import { userProfile } from "../../../redux/userProfile/action";
import { useForm } from "react-hook-form";
import { useAppDispatch } from "../../../hooks/hooks";
import { queryByStore } from "../../../redux/query-by-store/action";
import { organizationUnits } from "../../../redux/organizationUnits/action";
import { library } from "../../../redux/library/action";
import { countries } from "../../../redux/countries/action";
import { states } from "../../../redux/states/action";
import { channel } from "../../../redux/channel/action";
import PageLoader from "../../../components/PageLoader";
import storePersist from "../../../redux/storePersist";
import { tenantDetails } from "../../../request/request";
import { getHostName, getOrigin } from "../../../common/services/common.service";
import moment from "moment";
import EmailInput from "../../../common/components/EmailInput.Component";
import PasswordInput from "../../../common/components/PasswordInput.Component";
import { RotatingLines } from "react-loader-spinner";
import { metaTokens } from "../../../redux/meta-token/action";
export default function CSGPortalLogin() {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const naviage = useNavigate()
	const dispatch = useAppDispatch()
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();

	const [steps, setSteps] = useState({ Email: '', Password: '' })
	const [colorTheme, setTheme] = useDarkMode();
	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}


	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
	  setShowPassword(!showPassword);
	};

	const [darkSide, setDarkSide] = useState(
		colorTheme === "light" ? true : false
	);

	const toggleDarkMode = (checked: any) => {
		setTheme(colorTheme);
		setDarkSide(checked);
	};

	const onFinish = async () => {
		setIsLoading(true)
		const organizationUnits: any = JSON.parse(localStorage.getItem("organizationUnits") || "");
		await dispatch(login({ loginData: { 
			"Records": [
				{
					"Context": {
						"Subscription": "DBaasFusionnet",
						"Domain": "FusionNet",
						"SubDomains": [],
						"Network": "Internal",
						"Application": "CSG",
						"Channel": "CSP"
					},
					"Message": {
						"Username": steps?.Email,
						"Password": steps?.Password,
						"AccountType": "Internal",
						"LoginWithOtp": false,
						"Otp": "",
						"IsGoogleAuthenticated": false,
						"AuthenticatedUserId": "",
						"ClientIPAddress": "",
						"OrganizationUnitId": organizationUnits?.current[0].Id
					}
				}
			]
		
		} }))
		await	dispatch(userProfile.read({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`,entity: 'userProfile'}))
		.then(()=>{
			naviage('/csg-portal/organizations')
		})
		setIsLoading(false)
		clearErrors('Email')
		clearErrors('Password')
	};

	const apiCall =async ()=>{
		await dispatch(guestToken({
			loginData: [
				{
					"Context": {
						"domain": "string",
						"core_version": "string",
						"bap_id": getHostName(),
						"bap_uri": getOrigin(),
						"bpp_id": "string",
						"bpp_uri": "string",
						"city": "string",
						"country": "string",
						"action": "string",
						"transaction_id": "string",
						"message_id": "string",
						"timestamp": moment.utc(),
						"ttl": "string",
						"Subscription": "UCP",
						"Domain": "Fusionnet",
						"SubDomains": [
							
						],
						"Network": "Internal",
						"Application": "Platform",
						"Channel": "CSP"
					},
					"Message": {
						"AccountType": "Internal"
					}
				}
			]
		}));
		if(storePersist.get('tokenData').current?.success){
			await dispatch(metaTokens.resetAction({ actionType: 'list' }));
			await  dispatch(metaTokens.list({
				   url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/meta-token`, entity: 'metaTokens', jsonData: {
					   "Records": [
						   {
							   "Context": null,
							   "Message": {
							   }
						   }
					   ]
				   }
			   }))
		await dispatch(organizationUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,entity:'organizationUnits',jsonData:{}}))
		await dispatch(library.read({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`,entity:'library'}))
		await dispatch(countries.read({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`,entity:'countries'}))
		await dispatch(states.read({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`,entity:'states'}))
	}

}
	
useEffect(() => {
	apiCall()
		
}, [])

	return (<>
		<form onSubmit={handleSubmit(onFinish)} >
				<div className="flex h-screen bg-[#F8F8F8]">
					<div className="container mx-auto px-4 ">
						<div className="flex content-center items-center justify-start h-full">
							<div className="w-1/2 h-max px-6">
								<div className="bg-white flex flex-col items-end justify-around h-full">
									<div className="flex flex-col justify-center w-full h-screen px-4 px-3">
										<div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
											Log In
											<svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
										</div>
										<div className="w-full my-5">
										<EmailInput
											label="Email Address"
											name="Email"
											isRequired={true}
											register={register}
											errors={errors}
											setValue={setValue}
											handleSteps={(e: any) => handleSteps(e, 'Email')} 
										/>

										</div>
										<div className="w-full my-5 relative">
										<PasswordInput
											label="Password"
											name="Password"
											isRequired={true}
											// minLength={3}
											// maxLength={10}
											register={register}
											errors={errors}
											setValue={setValue}
											handleSteps={(e:any) => handleSteps(e, 'Password')} 
										/>
										</div>
										<div className="w-full my-5 flex flex-row justify-between mx-3">
											<label className="inline-flex items-center cursor-pointer">
												<input
													id="customCheckLogin"
													type="checkbox"
													className="form-checkbox"
												/>
												<span className="ml-2 text-md text-black">
													Remember me
												</span>
											</label>
											<div className="mr-4">
												<a
													href="#pablo"
													onClick={(e) => e.preventDefault()}
													className="text-yellow-500 text-xl"
												>
													<small>Forgot password?</small>
												</a>
											</div>
										</div>
										<div className="text-center mt-6">
										<button
												type="submit"
												disabled={isLoading}
												className={`${isLoading ? 'bg-black bg-opacity-70' : 'bg-black'
													} flex-row flex items-center justify-center text-white text-xl p-4 w-full h-11`}
											>
												Login
												<div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
													<RotatingLines
														visible={true}
														width={'20'}
														strokeColor="#fff"
														strokeWidth="6"
														animationDuration="0.75"
														ariaLabel="rotating-lines-loading"
													/>
												</div>
											</button>
										</div>
										<div className="flex flex-row mt-6 bg-[#FAFAFA] justify-center items-center w-full">
											<img src={require('./../../../assets/img/google.jpeg')} className="h-6 w-6" />

											<button
												className=" text-black text-opacity-50 text-xl p-2"
												type="button"
											>
												Sign In with Google
											</button>
										</div>
										<div className="w-full flex flex-row justify-center my-3 text-md text-black text-opacity-50">
											<div>Don't have any account ? </div>
											<div className="font-normal text-black text-opacity-100"> &nbsp;SignUp Free</div>
										</div>
									</div>
								</div>
							</div>
							<div className="w-1/2 h-screen  flex justify-center items-center px-20">
								<img src={require('../../../assets/img/cart.png')} />
							</div>
						</div>
					</div>
				</div >
			</form ></>
	);
}
